(function() { window.GUID_f739dd0d_1fae_4775_a999_3a221aba4f1b = { getGuid: function() { return "f739dd0d-1fae-4775-a999-3a221aba4f1b"; } }; })();


//# sourceMappingURL=IPrepareDataToSendGlobal.js.map
